<template>
    <div class="core_rate"  :class="{'core_rate_border': isBorder}">
        <ul v-for="(item,index) in scoreList" :key="index" class="score_list">
            <!--                第一层标题-->
            <li class="theme3A SysFontM trait_title Text_Over">{{item['value'+  $lang]}}</li>
            <li
                v-for="(childItem,indexS)  in item.child"
                :key="indexS"
                :class="childItem.child ? 'cont_childS' : 'cont_child'"
            >
                <el-popover
                    ref="popover"
                    popper-class="trial_el_popover"
                    trigger="hover"
                    placement="top"
                    class="ml4"
                    style="width:100%"
                >
                    <span slot="reference"  class="Text_Over" :class="childItem.child ?'child_title':'child_title_F'" >
                        {{childItem['value'+  $lang]}}
                    </span>
                    <ul class="hint" style="color:#fff;opacity:.8">
                        {{childItem['value'+  $lang]}}
                    </ul>
                </el-popover>

                <!-- 第二层循环 -->
                <ul v-if="childItem.child" class="cont_childS_list">
                    <li
                        v-for="(childSItem,indexSS)  in childItem.child"
                        :key="indexSS"
                        class="childSItemLi"
                    >
                        <el-popover
                                ref="popover"
                                popper-class="trial_el_popover"
                                trigger="hover"
                                placement="top"
                                class="ml4"
                                :content="childSItem['value'+  $lang]"
                        >
                             <span slot="reference"  class="Text_Over" :class="childSItem.child ? 'indexCSpan' : 'indexSSSpan'">
                                 {{ childSItem['value' + $lang]}}
                             </span>
                        </el-popover>

                        <!-- 第三层循环 -->
                        <ul v-if="childSItem.child" class="cont_childSS_list">
                            <li
                                v-for="(childSSItem,indexSSS)  in childSItem.child"
                                :key="indexSSS"
                                class="childSSItemLi"
                            >
                                <span class="indexSSSSpan indexSSSSpanLeft" v-if="indexSSS==0">L</span>
                                <span class="indexSSSSpan" v-if="indexSSS==1">R</span>
                                <cl-score :starNumber="childSSItem.number || 5" @change="changeRage" class="el-rate "  v-model="childSSItem.score"></cl-score>
                            </li>
                        </ul>
                        <!-- 第二层展示 -->
                        <cl-score :starNumber="childSItem.number || 5" @change="changeRage"  v-else  v-model="childSItem.score"></cl-score>
                    </li>
                </ul>
                <!-- 第一层 真是-->
                <!-- 标题为 其他数据时 为select -->
                <el-select
                    class="select_rate"
                    style="width:90%"
                    v-model="childItem.score"
                    v-else-if="item.key=='remaining-data-of-player'"
                    @change="changeRage"
                >
                    <el-option label="YES" value="yes"></el-option>
                    <el-option label="NO" value="no"></el-option>
                </el-select>
                <cl-score :starNumber="childItem.number || 5" @change="changeRage"  v-else  class="el-rate"   v-model="childItem.score"></cl-score>
            </li>
        </ul>
    </div>
</template>

<script>
import ClScore from "./index";
export default {
    name: "ts-score-rate",
    components: {ClScore},
    props: {
        //评分列表
        scoreList: {
            type: Array,
            default: () => {
                return []
            }
        },
        //显示类型
        showType: {
            type: String,
            default: 'ESR'
        },
        //星星后边是否有边框
        isBorder:{
            type: Boolean,
            default: false
        }
    },
    methods: {
        changeRage () {
            this.$forceUpdate();
            this.$emit('changeRage')
        }
    }
}
</script>

<style scoped lang="scss">
.core_rate {
    width: calc(100% + 5%);
    height: auto;
    .trait_title {
        font-size: 14px;
        line-height: 20px;
        padding-bottom: 16px;
    }
    .trait_score {
        display: flex;
        flex-wrap: wrap;
        li {
            min-width: 33%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            padding-bottom: 24px;
            box-sizing: border-box;
            padding-right:3% ;
            .trait_score_name {
                width:80%;
                font-size: 14px;
                line-height: 30px;
                padding-bottom: 4px;
                color: #81818A;
            }

            &:last-child {
                padding-bottom: 0;
            }
            &:nth-last-child(2) {
                padding-bottom: 0;
            }
        }
    }
    .score_list {
        width: calc(100% + 5%);
        height: auto;
        display: flex;
        flex-wrap: wrap;
        .trait_title {
            width: 80%;
        }
        .cont_child,
        .cont_childS {
            box-sizing: border-box;
            width:31.5%;
            display: flex;
            flex-direction: column;
            min-height: 32px;
            padding-bottom: 24px;
            padding-right:3% ;
            .child_title_F,
            .child_title {
                font-size: 14px;
                line-height: 30px;
                color: #81818A;
                padding-bottom: 4px;
                // color:#fff;
                // opacity:.8
            }
            .child_title_F {
                width:80%;
            }
            .child_title {
                min-width: 68px;
                font-size: 14px;
                line-height: 20px;
                color: #3663E1;
                padding: 4px 8px;
                border-radius: 2px;
                box-sizing: border-box;
                text-align: center;
                background: rgba(54, 99, 225, 0.1);
                margin-bottom: 16px;
            }
        }
        .cont_childS {
            width: calc(100% + 5%);
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: flex-start;
            .cont_childS_list {
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .childSItemLi {
                    display: flex;
                    min-width: 32.5%;
                    flex-direction: column;
                    min-height: 32px;
                    padding-bottom: 24px;
                    box-sizing: border-box;
                    .indexSSSpan,
                    .indexCSpan {
                        font-family: SysFontM;
                        font-size: 14px;
                        line-height: 30px;
                        color: #81818A;
                        width: 70%;
                        max-width: 160px;
                    }
                    .indexCSpan {
                        width: 70%;
                    }
                    /*LR循环*/
                    .cont_childSS_list {
                        margin-right: 80px;
                        .childSSItemLi {
                            display: flex;
                            align-items: center;
                            min-height: 32px;
                            .indexSSSSpan {
                                font-family: SysFontR;
                                margin-right: 14px;
                                color: #81818A;
                                margin-top: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}
/*    边框*/
    .core_rate_border{
        .trait_score {
            li {
                border-right: 1px solid #E9EDF3;
                &:nth-child(3n - 1){
                    padding-left: 24px;
                }
                &:nth-child(3n){
                    border: none;
                    margin: 0;
                    padding-left: 24px;
                }
            }
        }
        .score_list {
            .cont_child,
            .cont_childS {
                border-right: 1px solid #E9EDF3;
                &:nth-child(3n){
                    padding-left: 24px;
                }
                &:nth-child(3n + 1){
                    padding-left: 24px;
                    border: none;
                }
            }
            .cont_childS {
                &:nth-child(3n){
                    padding-left:0;
                }
                &:nth-child(3n + 1){
                    padding-left:0;
                }
                .cont_childS_list {

                    .childSItemLi {
                        border-right: 1px solid #E9EDF3;
                        &:nth-child(3n - 1){
                            padding-left: 24px;
                        }
                        &:nth-child(3n){
                            border: none;
                            padding-left: 24px;
                        }
                    }
                }
            }
        }

    }
</style>
